import type { MapRef } from 'react-map-gl/mapbox';

import { getZoomForLocationType } from '../search/utils';
import type { MapLocation } from './types';

export const LOCATION_FLY_EVENT_DATA = { odSkipViewportSearch: true } as const;

type SearchMap = Pick<MapRef, 'isMoving'> & {
  flyTo: (...args: Parameters<MapRef['flyTo']>) => void;
  stop: () => void;
  once: (event: 'moveend', listener: () => void) => void;
  off: (event: 'moveend', listener: () => void) => void;
};

export const flyToSearchLocation = ({
  map,
  location,
  onComplete,
}: {
  map: SearchMap;
  location: MapLocation & { coordinates: [number, number] };
  onComplete: () => void;
}): (() => void) => {
  // Finish an earlier animation before subscribing to this selection's moveend.
  map.stop();
  let pending = true;
  const cancel = () => {
    pending = false;
    map.off('moveend', complete);
  };
  const complete = () => {
    if (!pending) {
      return;
    }
    cancel();
    onComplete();
  };
  map.once('moveend', complete);
  map.flyTo(
    { center: location.coordinates, zoom: getZoomForLocationType(location.zoneType) },
    LOCATION_FLY_EVENT_DATA,
  );
  // A repeated selection or reduced-motion preference can finish synchronously.
  if (!map.isMoving()) {
    complete();
  }
  return cancel;
};
